import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ApiTeaser() {
  const codeLines: Array<Array<{
    text: string;
    className?: string;
  }>> = [[{
    text: 'import',
    className: 'text-purple-400'
  }, {
    text: ' { GetCozy } '
  }, {
    text: 'from',
    className: 'text-purple-400'
  }, {
    text: ' '
  }, {
    text: "'@getcozy/sdk'",
    className: 'text-green-400'
  }, {
    text: ';'
  }], [], [{
    text: 'const',
    className: 'text-purple-400'
  }, {
    text: ' cozy = '
  }, {
    text: 'new',
    className: 'text-purple-400'
  }, {
    text: ' GetCozy(process.env.COZY_API_KEY);'
  }], [], [{
    text: '// Query the memory graph with natural language',
    className: 'text-gray-500'
  }], [{
    text: 'const',
    className: 'text-purple-400'
  }, {
    text: ' response = '
  }, {
    text: 'await',
    className: 'text-purple-400'
  }, {
    text: ' cozy.memory.query({'
  }], [{
    text: '  prompt: '
  }, {
    text: '"What are the action items from the design sync?"',
    className: 'text-green-400'
  }, {
    text: ','
  }], [{
    text: '  filters: {'
  }], [{
    text: '    sources: ['
  }, {
    text: "'slack'",
    className: 'text-green-400'
  }, {
    text: ', '
  }, {
    text: "'zoom_transcripts'",
    className: 'text-green-400'
  }, {
    text: '],'
  }], [{
    text: '    dateRange: '
  }, {
    text: "'last_7_days'",
    className: 'text-green-400'
  }], [{
    text: '  }'
  }], [{
    text: '});'
  }], [], [{
    text: 'console.log(response.answer);'
  }], [{
    text: '// Output: "1. Update the nav component. 2. Fix mobile padding..."',
    className: 'text-gray-500'
  }], [], [{
    text: 'console.log(response.citations);'
  }], [{
    text: "// Output: [{ source: 'slack', url: '...', text: '...' }]",
    className: 'text-gray-500'
  }]];
  return <section className="py-24 bg-[#0A0A0A] text-white relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: 'radial-gradient(#333 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-16" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-17">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-18">
          <div data-id="element-19">
            <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-20">
              Built for developers.
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-21">
              GetCozy isn't just a UI. It's a powerful API that lets you embed
              context-aware AI into your own applications. Query the memory
              graph, trigger skills, and manage sources programmatically.
            </p>
            <div className="flex gap-4" data-id="element-22">
              <a href="#" className="bg-white text-black px-6 py-3 rounded-full font-medium hover:bg-gray-200 transition-colors" data-id="element-23">
                Read the Docs
              </a>
              <a href="#" className="border border-gray-700 text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 transition-colors" data-id="element-24">
                API Reference
              </a>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-xl overflow-hidden border border-gray-800 shadow-2xl" data-id="element-25">
            <div className="bg-gray-900 px-4 py-3 flex items-center gap-2 border-b border-gray-800" data-id="element-26">
              <div className="w-3 h-3 rounded-full bg-red-500/80" data-id="element-27" />
              <div className="w-3 h-3 rounded-full bg-amber-500/80" data-id="element-28" />
              <div className="w-3 h-3 rounded-full bg-green-500/80" data-id="element-29" />
              <span className="ml-2 text-xs font-mono text-gray-500" data-id="element-30">
                query.ts
              </span>
            </div>
            <div className="p-6 bg-[#050505] font-mono text-sm overflow-x-auto" data-id="element-31">
              <pre className="text-gray-300 leading-relaxed" data-id="element-32">
                {codeLines.map((line, i) => <div key={i} className="min-h-[1.4em]" data-id="element-33">
                    {line.map((tok, j) => <span key={j} className={tok.className} data-id="element-34">
                        {tok.text}
                      </span>)}
                  </div>)}
              </pre>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}